var fn = function( obj ){
var __t,__p='';
__p+='#pragma SLOT version\n\n#pragma SLOT definitions\n\n#pragma SLOT precision\n\n'+
( require( "nanogl-pbr/glsl/includes/glsl-compat.vert" )() )+
'\n#pragma SLOT pv\n\nIN vec3 aPosition;\nIN vec2 aTexCoord0;\n\nuniform mat4 uWorldMatrix;\nuniform mat4 uVP;\n\nOUT vec3 vTexCoord;\n\nvec3 rotate( mat4 m, vec3 v )\n{\n  return m[0].xyz*v.x + m[1].xyz*v.y + m[2].xyz*v.z;\n}\n\nvoid main(void){\n\n  vec3 worldPosition = (uWorldMatrix * vec4(aPosition, 1.0)).xyz;\n  gl_Position = uVP * vec4(worldPosition, 1.0);\n\n  #if HAS_progress\n  vTexCoord = vec3(aTexCoord0 + texcoordOffset(), (aTexCoord0.x - 0.25) * 2.0);\n  #else\n  vTexCoord = vec3(aTexCoord0 + texcoordOffset(), 0.0);\n  #endif\n\n}';
return __p;
};
fn.toString=fn;
module.exports = fn;